import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { InformesService } from 'app/services/informes.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-tel-post-servicio',
  templateUrl: './tel-post-servicio.component.html',
  styleUrls: ['./tel-post-servicio.component.scss']
})
export class TelPostServicioComponent implements OnInit {

  //DataTable
  public dtOptions;
  public tableOpt;
  @ViewChild(DataTableDirective, {static:true})
  tabla: DataTableDirective;
  public dtTrigger: Subject<void>


  constructor(private _informe: InformesService) { 
    this.dtTrigger = new Subject();
    this.dtTrigger.next();

    this.tableOpt = [];
    this.dtOptions = {
      columns: [
        {
          title: 'N° Historia',
          data: 'reqcsc'  
        },
        {
          title: 'Fecha',
          data: 'reqdia' 
        },
        {
          title: 'Teléfono',
          data: 'reqtel' 
        }
      ]
    }
  }
  
  @Input() doc_beneficiario: string;

  ngOnInit() {
    this._informe.ServiciosBeneficiarios(this.doc_beneficiario).subscribe((data:any) => {
      this.tableOpt = data.resultado;
      this.dtTrigger.next();
    });
  }


}
